import React, { useState } from "react";
import { Container, Typography, Box, Tabs, Tab, Paper } from "@mui/material";
import {
  ListAlt as RosterIcon,
  Assessment as ReportIcon,
  QrCode as QrIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { AdminDailyRoster } from "../../components/teacher-attendance/AdminDailyRoster";
import { AdminMonthlyReport } from "../../components/teacher-attendance/AdminMonthlyReport";
import { QrCodeDisplay } from "../../components/teacher-attendance/QrCodeDisplay";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`attendance-tabpanel-${index}`}
      aria-labelledby={`attendance-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

const AdminAttendancePage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">
          {t("teacher_attendance_admin", "Teacher Attendance Console")}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Paper elevation={1} sx={{ borderRadius: 2, bgcolor: "background.paper" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": {
              fontWeight: 600,
              py: 2,
            },
          }}
        >
          <Tab
            icon={<RosterIcon />}
            iconPosition="start"
            label={t("daily_roster", "Daily Roster")}
            id="attendance-tab-0"
          />
          <Tab
            icon={<ReportIcon />}
            iconPosition="start"
            label={t("monthly_reports", "Monthly Report & Exports")}
            id="attendance-tab-1"
          />
          <Tab
            icon={<QrIcon />}
            iconPosition="start"
            label={t("qr_display", "QR Code Projector")}
            id="attendance-tab-2"
          />
        </Tabs>

        <Box sx={{ px: 3 }}>
          <TabPanel value={activeTab} index={0}>
            <AdminDailyRoster />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <AdminMonthlyReport />
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ maxWidth: "600px", width: "100%" }}>
                <QrCodeDisplay />
              </Box>
            </Box>
          </TabPanel>
        </Box>
      </Paper>
    </Container>
  );
};

export default AdminAttendancePage;
